module.exports = __webpack_public_path__ + "img/lacrosse_m.755b862f.svg";